// src/public/testTimeLimits.js
// Duración de cada test (en minutos), según su tipo.
// Mantener sincronizado con el mapa de duraciones del email en el backend
// (server/src/models/reasoningTest.model.js → sendMultipleTestsEmail).
export const TEST_TIME_LIMITS = {
    wordAssociation: 9,
    logicalProcess: 20,
    numericalReasoning: 9,
    socialContext: 11,
    logicalAbstract: 11,
    integrityTest: 15,
    emotionalIntelligence: 10,
};

export const DEFAULT_TIME_LIMIT = 10; // minutos (fallback)

export const getTestTimeLimit = (testType) =>
    TEST_TIME_LIMITS[testType] || DEFAULT_TIME_LIMIT;
